import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const postFeedback = (data) => axios.post(`${API}/feedback`, data);
export const postPrescription = (data) => axios.post(`${API}/prescription-request`, data);
export const postAppointment = (data) => axios.post(`${API}/appointment-request`, data);
export const postScreeningContact = (data) => axios.post(`${API}/screening-contact`, data);
export const postDoctorInvite = (data) => axios.post(`${API}/doctor-invite`, data);
export const postContactRequest = (data) => axios.post(`${API}/contact-request`, data);
